(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let lastFocusedElement = null;

  const setBodyLock = (locked) => document.body.classList.toggle('is-locked', locked);

  const openLayer = (element, trigger) => {
    if (!element) return;
    lastFocusedElement = trigger || document.activeElement;
    element.hidden = false;
    requestAnimationFrame(() => element.classList.add('is-open'));
    trigger?.setAttribute('aria-expanded', 'true');
    setBodyLock(true);
    const focusTarget = $('input, button, a[href], select', element);
    window.setTimeout(() => focusTarget?.focus(), reducedMotion ? 0 : 180);
  };

  const closeLayer = (element, triggerSelector) => {
    if (!element) return;
    element.classList.remove('is-open');
    $$(triggerSelector || '[aria-expanded="true"]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { element.hidden = true; }, reducedMotion ? 0 : 220);
    if (!document.querySelector('.is-open')) setBodyLock(false);
    lastFocusedElement?.focus?.();
  };

  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.items = $$('[data-announcement]', this);
      this.index = 0;
      this.paused = false;
      this.control = $('[data-announcement-pause]', this);
      this.control?.addEventListener('click', () => {
        this.paused = !this.paused;
        this.control.setAttribute('aria-label', this.paused ? 'Play announcements' : 'Pause announcements');
        this.control.querySelector('.icon').innerHTML = this.paused
          ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 9 6-9 6V6Z"></path></svg>'
          : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"></path></svg>';
      });
      if (this.dataset.rotate === 'true' && this.items.length > 1 && !reducedMotion) {
        this.timer = window.setInterval(() => { if (!this.paused) this.show(this.index + 1); }, Number(this.dataset.interval) || 6000);
      }
    }

    disconnectedCallback() { window.clearInterval(this.timer); }

    show(index) {
      this.items[this.index].hidden = true;
      this.items[this.index].classList.remove('is-active');
      this.index = index % this.items.length;
      this.items[this.index].hidden = false;
      requestAnimationFrame(() => this.items[this.index].classList.add('is-active'));
    }
  }
  customElements.define('announcement-rotator', AnnouncementRotator);

  const refreshCartDrawer = async (openAfter = false) => {
    const sectionUrl = `${window.theme.routes.root}${window.theme.routes.root.includes('?') ? '&' : '?'}section_id=cart-drawer`;
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(sectionUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
      fetch(`${window.theme.routes.cart}.js`, { headers: { Accept: 'application/json' } })
    ]);
    if (!sectionResponse.ok || !cartResponse.ok) throw new Error(window.theme.strings.cartError);
    const html = await sectionResponse.text();
    const cart = await cartResponse.json();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextDrawer = $('[data-cart-drawer]', parsed);
    const currentDrawer = $('[data-cart-drawer]');
    if (nextDrawer && currentDrawer) {
      currentDrawer.replaceWith(nextDrawer);
      const nextScrim = nextDrawer.nextElementSibling;
      const currentScrims = $$('[data-cart-close].drawer-scrim');
      if (nextScrim?.matches('.drawer-scrim') && currentScrims.length) currentScrims[0].replaceWith(nextScrim);
    }
    $$('[data-cart-count]').forEach((count) => {
      count.textContent = cart.item_count;
      count.hidden = cart.item_count === 0;
    });
    if (openAfter) openLayer($('[data-cart-drawer]'), $('[data-cart-open]'));
  };
  window.refreshCartDrawer = refreshCartDrawer;

  const addToCart = async (form) => {
    const submit = form.querySelector('[type="submit"]:focus') || form.querySelector('[type="submit"]');
    const error = $('[data-product-form-error]', form) || $('[data-cart-error]');
    submit?.setAttribute('aria-busy', 'true');
    submit?.setAttribute('disabled', 'disabled');
    if (error) error.hidden = true;
    try {
      const formData = new FormData(form);
      if (submit?.name && submit?.value) formData.set(submit.name, submit.value);
      const response = await fetch(`${window.theme.routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || window.theme.strings.cartError);
      form.closest('dialog')?.close();
      await refreshCartDrawer(true);
    } catch (err) {
      if (error) { error.textContent = err.message; error.hidden = false; }
    } finally {
      submit?.removeAttribute('aria-busy');
      submit?.removeAttribute('disabled');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', async (event) => {
    const target = event.target;
    const mobileOpen = target.closest('[data-mobile-menu-open]');
    const mobileClose = target.closest('[data-mobile-menu-close]');
    const cartOpen = target.closest('[data-cart-open]');
    const cartClose = target.closest('[data-cart-close]');
    const searchOpen = target.closest('[data-search-open]');
    const searchClose = target.closest('[data-search-close]');
    const filterOpen = target.closest('[data-filter-open]');
    const filterClose = target.closest('[data-filter-close]');
    const sizeOpen = target.closest('[data-size-guide-open]');
    const sizeClose = target.closest('[data-size-guide-close]');
    const dialogOpen = target.closest('[data-dialog-open]');
    const dialogClose = target.closest('[data-dialog-close]');
    const cardVideoToggle = target.closest('[data-card-video-toggle]');

    if (mobileOpen) {
      openLayer($('[data-mobile-menu]'), mobileOpen);
      const scrim = $('[data-mobile-menu-close].drawer-scrim'); if (scrim) scrim.hidden = false;
    }
    if (mobileClose) { closeLayer($('[data-mobile-menu]'), '[data-mobile-menu-open]'); $$('[data-mobile-menu-close].drawer-scrim').forEach((scrim) => { scrim.hidden = true; }); }
    if (cartOpen) { event.preventDefault(); openLayer($('[data-cart-drawer]'), cartOpen); const scrim = $('[data-cart-close].drawer-scrim'); if (scrim) scrim.hidden = false; }
    if (cartClose) { closeLayer($('[data-cart-drawer]'), '[data-cart-open]'); $$('[data-cart-close].drawer-scrim').forEach((scrim) => { scrim.hidden = true; }); }
    if (searchOpen) { openLayer($('[data-search-overlay]'), searchOpen); }
    if (searchClose) { closeLayer($('[data-search-overlay]'), '[data-search-open]'); }
    if (filterOpen) { openLayer($('[data-filter-drawer]'), filterOpen); const scrim = $('[data-filter-close].drawer-scrim'); if (scrim) scrim.hidden = false; }
    if (filterClose) { closeLayer($('[data-filter-drawer]'), '[data-filter-open]'); $$('[data-filter-close].drawer-scrim').forEach((scrim) => { scrim.hidden = true; }); }
    if (sizeOpen) { openLayer($('[data-size-guide]'), sizeOpen); const scrim = $('[data-size-guide-close].drawer-scrim'); if (scrim) scrim.hidden = false; }
    if (sizeClose) { closeLayer($('[data-size-guide]'), '[data-size-guide-open]'); $$('[data-size-guide-close].drawer-scrim').forEach((scrim) => { scrim.hidden = true; }); }
    if (dialogOpen) { const dialog = document.getElementById(dialogOpen.dataset.dialogOpen); dialog?.showModal(); }
    if (dialogClose) dialogClose.closest('dialog')?.close();

    if (cardVideoToggle) {
      const video = cardVideoToggle.parentElement.querySelector('.product-card__video');
      if (video?.paused) { video.dataset.userPaused = 'false'; await video.play(); cardVideoToggle.setAttribute('aria-label', 'Pause video'); }
      else if (video) { video.dataset.userPaused = 'true'; video.pause(); cardVideoToggle.setAttribute('aria-label', 'Play video'); }
      const icon = cardVideoToggle.querySelector('.icon');
      if (icon && video) icon.innerHTML = video.paused
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 9 6-9 6V6Z"></path></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"></path></svg>';
    }

    const videoToggle = target.closest('[data-video-toggle]');
    if (videoToggle) {
      const video = videoToggle.parentElement.querySelector('video');
      if (!video) return;
      if (video.paused) { await video.play(); videoToggle.setAttribute('aria-label', 'Pause video'); }
      else { video.pause(); videoToggle.setAttribute('aria-label', 'Play video'); }
      videoToggle.classList.toggle('is-paused', video.paused);
      const icon = videoToggle.querySelector('.icon');
      if (icon) icon.innerHTML = video.paused
        ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 9 6-9 6V6Z"></path></svg>'
        : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"></path></svg>';
    }

    const quantityButton = target.closest('[data-cart-quantity]');
    const removeButton = target.closest('[data-cart-remove]');
    if (quantityButton || removeButton) {
      const item = target.closest('[data-cart-item]');
      if (!item) return;
      const quantity = removeButton ? 0 : Number(quantityButton.dataset.cartQuantity);
      try {
        const response = await fetch(`${window.theme.routes.cartChange}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(item.dataset.line), quantity }) });
        if (!response.ok) throw new Error(window.theme.strings.cartError);
        await refreshCartDrawer(true);
      } catch (err) {
        const cartError = $('[data-cart-error]'); if (cartError) { cartError.textContent = err.message; cartError.hidden = false; }
      }
    }

    const cardSwatch = target.closest('[data-card-swatch]');
    if (cardSwatch) {
      const card = cardSwatch.closest('[data-product-card]');
      const variants = JSON.parse($('[data-card-variants]', card).textContent);
      const variant = variants.find((item) => String(item.id) === cardSwatch.dataset.variantId);
      if (!variant) return;
      $$('[data-card-swatch]', card).forEach((swatch) => { const active = swatch === cardSwatch; swatch.classList.toggle('is-selected', active); swatch.setAttribute('aria-pressed', active); });
      if (variant.image) { const image = $('.product-card__image--primary', card); image.src = variant.image; image.srcset = ''; }
      $$('[data-card-link]', card).forEach((link) => { link.href = variant.url; });
      const colour = $('[data-card-color]', card); if (colour) colour.textContent = variant.color || '';
      const price = $('[data-price]', card); if (price) price.textContent = variant.price;
      const compare = $('[data-compare-price]', card); if (compare) { compare.textContent = variant.comparePrice || ''; compare.hidden = !variant.comparePrice; }
      card.dataset.selectedVariant = variant.id;
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = $('.search-overlay.is-open, .mobile-menu.is-open, .cart-drawer.is-open, .filter-drawer.is-open, .size-guide-drawer.is-open');
    if (open) {
      closeLayer(open);
      $$('.drawer-scrim').forEach((scrim) => { scrim.hidden = true; });
    }
  });

  let searchTimer;
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-predictive-search-input]');
    if (!input) return;
    window.clearTimeout(searchTimer);
    const results = $('[data-predictive-search-results]');
    if (input.value.trim().length < 2) { results.innerHTML = '<p class="search-overlay__prompt">Type at least two characters.</p>'; return; }
    searchTimer = window.setTimeout(async () => {
      try {
        const url = `${window.theme.routes.predictiveSearch}?q=${encodeURIComponent(input.value)}&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search`;
        const response = await fetch(url);
        if (!response.ok) throw new Error();
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        results.innerHTML = ($('#shopify-section-predictive-search', parsed) || parsed.body).innerHTML;
        input.setAttribute('aria-expanded', 'true');
      } catch (_) { results.innerHTML = '<p>Search is temporarily unavailable.</p>'; }
    }, 220);
  });

  const updateCollection = async (url, updateHistory = true) => {
    const section = $('[data-collection-section]');
    if (!section) return;
    const sectionId = section.dataset.sectionId;
    const requestUrl = new URL(url, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    section.classList.add('is-loading');
    try {
      const response = await fetch(requestUrl.toString());
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextSection = $(`[data-collection-section]`, parsed);
      if (nextSection) section.replaceWith(nextSection);
      requestUrl.searchParams.delete('section_id');
      if (updateHistory) history.pushState({}, '', requestUrl.pathname + requestUrl.search);
      setBodyLock(false);
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    } finally { section.classList.remove('is-loading'); }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    event.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    updateCollection(`${window.location.pathname}?${params.toString()}`);
  });

  let facetTimer;
  document.addEventListener('change', (event) => {
    const giftToggle = event.target.closest('[data-gift-recipient-toggle]');
    if (giftToggle) {
      const fields = giftToggle.closest('.gift-recipient').querySelector('[data-gift-recipient-fields]');
      fields.hidden = !giftToggle.checked;
      $$('[data-gift-recipient-input]', fields).forEach((input) => { input.disabled = !giftToggle.checked; });
    }
    const localization = event.target.closest('[data-localization-select]');
    if (localization) localization.form.submit();
    const sort = event.target.closest('[data-sort-select]');
    if (sort) { const params = new URLSearchParams(window.location.search); params.set('sort_by', sort.value); params.delete('page'); updateCollection(`${window.location.pathname}?${params.toString()}`); }
    const facetInput = event.target.closest('[data-facets-form] input');
    if (facetInput && facetInput.type !== 'number') {
      window.clearTimeout(facetTimer);
      facetTimer = window.setTimeout(() => facetInput.form.requestSubmit(), 180);
    }
  });
  window.addEventListener('popstate', () => updateCollection(window.location.href, false));

  const header = $('[data-site-header]');
  if (header) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    updateHeader(); window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const cardVideoObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && video.dataset.userPaused !== 'true' && !reducedMotion) video.play().catch(() => {});
      else video.pause();
    });
  }, { threshold: [0, 0.5] });
  const observeCardVideos = (context = document) => {
    $$('.product-card__video', context).forEach((video) => {
      if (video.dataset.videoObserved) return;
      video.dataset.videoObserved = 'true';
      cardVideoObserver.observe(video);
    });
  };
  observeCardVideos();
  new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType === 1) observeCardVideos(node);
  }))).observe(document.body, { childList: true, subtree: true });

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetch(this.dataset.url).then((response) => response.text()).then((html) => {
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const recommendations = $('product-recommendations', parsed);
          if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
        });
      }, { rootMargin: '300px' });
      observer.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  const recentlyViewed = $('[data-recently-viewed]');
  if (recentlyViewed) {
    const key = 'nineteen-active-recently-viewed';
    const current = recentlyViewed.dataset.currentProduct;
    const stored = JSON.parse(localStorage.getItem(key) || '[]').filter((handle) => handle && handle !== current);
    const visible = stored.slice(0, Number(recentlyViewed.dataset.limit) || 4);
    const grid = $('[data-recently-viewed-grid]', recentlyViewed);
    const root = window.theme.routes.root.endsWith('/') ? window.theme.routes.root : `${window.theme.routes.root}/`;
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: window.Shopify?.currency?.active || 'GBP' }).format(cents / 100);
    const sizedImage = (src) => src ? src.replace(/(\.[a-z0-9]+)(\?.*)?$/i, '_720x$1$2') : '';
    const createCard = (product) => {
      const selected = product.variants.find((variant) => variant.available) || product.variants[0];
      const card = document.createElement('article'); card.className = 'product-card';
      const media = document.createElement('div'); media.className = 'product-card__media media-ratio media-ratio--portrait';
      const mediaLink = document.createElement('a'); mediaLink.className = 'product-card__image-link'; mediaLink.href = `${root}products/${product.handle}?variant=${selected.id}`;
      const image = document.createElement('img'); image.className = 'product-card__image product-card__image--primary'; image.loading = 'lazy'; image.alt = product.title; image.src = sizedImage(selected.featured_image?.src || product.featured_image || product.images?.[0]);
      mediaLink.append(image); media.append(mediaLink);
      const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',').map((tag) => tag.trim());
      const badgeText = ['New Arrival', 'Bestseller', 'Limited', 'Online Exclusive'].find((tag) => tags.includes(tag)) || (selected.compare_at_price > selected.price ? 'Sale' : '');
      if (badgeText) { const badge = document.createElement('span'); badge.className = 'product-card__badge'; badge.textContent = badgeText; media.append(badge); }

      const info = document.createElement('div'); info.className = 'product-card__info';
      const colorOptionIndex = product.options.findIndex((option) => ['color', 'colour'].includes(String(option.name || option).toLowerCase()));
      const colorName = document.createElement('p'); colorName.className = 'product-card__colour';
      if (colorOptionIndex >= 0) {
        const swatches = document.createElement('div'); swatches.className = 'product-card__swatches'; swatches.setAttribute('role', 'group'); swatches.setAttribute('aria-label', 'Colour');
        const values = [...new Set(product.variants.map((variant) => variant.options[colorOptionIndex]))].slice(0, 5);
        values.forEach((value) => {
          const variant = product.variants.find((item) => item.options[colorOptionIndex] === value && item.available) || product.variants.find((item) => item.options[colorOptionIndex] === value);
          const swatchSelected = value === selected.options[colorOptionIndex];
          const swatch = document.createElement('button'); swatch.type = 'button'; swatch.className = `swatch${swatchSelected ? ' is-selected' : ''}`; swatch.setAttribute('aria-label', value); swatch.setAttribute('aria-pressed', String(swatchSelected));
          const dot = document.createElement('span'); dot.style.setProperty('--swatch-color', value.toLowerCase());
          if (variant.featured_image?.src) dot.style.setProperty('--swatch-image', `url("${sizedImage(variant.featured_image.src)}")`);
          swatch.append(dot);
          swatch.addEventListener('click', () => {
            [...swatches.children].forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
            swatch.classList.add('is-selected'); swatch.setAttribute('aria-pressed', 'true');
            image.src = sizedImage(variant.featured_image?.src || product.featured_image || product.images?.[0]);
            mediaLink.href = `${root}products/${product.handle}?variant=${variant.id}`; titleLink.href = mediaLink.href;
            colorName.textContent = value; currentPrice.textContent = money(variant.price);
            compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : ''; compare.hidden = !(variant.compare_at_price > variant.price);
            price.classList.toggle('price--sale', variant.compare_at_price > variant.price);
          });
          swatches.append(swatch);
        });
        info.append(swatches); colorName.textContent = selected.options[colorOptionIndex];
      }
      const title = document.createElement('h3'); title.className = 'product-card__title';
      const titleLink = document.createElement('a'); titleLink.href = mediaLink.href; titleLink.textContent = product.title; title.append(titleLink); info.append(title);
      if (colorOptionIndex >= 0) info.append(colorName);
      const price = document.createElement('div'); price.className = `price${selected.compare_at_price > selected.price ? ' price--sale' : ''}`;
      const currentPrice = document.createElement('span'); currentPrice.className = 'price__current'; currentPrice.textContent = money(selected.price);
      const compare = document.createElement('s'); compare.className = 'price__compare'; compare.textContent = selected.compare_at_price > selected.price ? money(selected.compare_at_price) : ''; compare.hidden = !(selected.compare_at_price > selected.price);
      price.append(currentPrice, compare); info.append(price); card.append(media, info); return card;
    };
    Promise.all(visible.map((handle) => fetch(`${root}products/${handle}.js`).then((response) => response.ok ? response.json() : null))).then((products) => {
      products.filter(Boolean).forEach((product) => grid.append(createCard(product)));
      if (!grid.children.length) recentlyViewed.hidden = true;
    });
    localStorage.setItem(key, JSON.stringify([current, ...stored].slice(0, 8)));
  }
})();
